import { Injectable } from '@angular/core';
import { ImportToFusionApiService, ImportToFusionResponseDto } from '@api/import-to-fusion';
import { ApiConnectionsRepository, WorkspaceRepository } from '@database/central';
import { ExportJSONFileModel, FileExporterDataProvider } from '@domain/json-file-exporter';
import { LoggingService } from '@shared/logging';
import { map, Observable, switchMap, throwError, from } from 'rxjs';
import { DeviceIdProvider } from '@database/workspace';

@Injectable({
	providedIn: 'root'
})
export class ApiExporterService {
	private AUTHENTHICATION_METHOD = 'Database Authentication';
	public currentDeviceId: string;

	public constructor(
		private importToFusionApi: ImportToFusionApiService,
		private fileExporterDataProvider: FileExporterDataProvider,
		private workspaceRepository: WorkspaceRepository,
		private apiConnectionsRepository: ApiConnectionsRepository,
		private loggingService: LoggingService,
		private deviceIdProvider: DeviceIdProvider
	) {}

	public exportToFusion$(workfileId: string): Observable<ImportToFusionResponseDto> {
		return this.workspaceRepository.getConnectionId$(workfileId).pipe(
			switchMap((connectionId: string) => {
				this.loggingService.info('ApiExporterService', 'Triggered by getConnectionId ' + connectionId);

				return this.apiConnectionsRepository.getConnectionDetails$(connectionId).pipe(
					map((result) => result.selectedOptions.database),
					switchMap((environment: string) =>
						this.fileExporterDataProvider.export$(workfileId).pipe(
							switchMap((workfile: ExportJSONFileModel) => {
								this.loggingService.info('ApiExporterService', 'Export workfile');

								return from(this.checkDeviceId(JSON.stringify(workfile))).pipe(
									switchMap((result) => {
										
										return this.importToFusionApi.importToFusion$(connectionId, {
											Workfile: result,
											AuthenticationMethod: this.AUTHENTHICATION_METHOD,
											Environment: environment
										});
									})
								);

							}),
							map((response) => {
								if (response) {
									throwError(() => response);
								}
								return response;
							})
						)
					)
				);
			})
		);
	}

	public async archiveWorkifle(workfileId: string): Promise<void> {
		await this.workspaceRepository.archiveWorkfile(workfileId);
	}


	public async checkDeviceId(workfile: string): Promise<string> {
		this.currentDeviceId = await this.deviceIdProvider.getDeviceId();
		const parsedWorkfile = JSON.parse(workfile);
		parsedWorkfile.FusionConfigHeader[0].device_id = this.currentDeviceId;

		const modifiedWorkfile = JSON.stringify(parsedWorkfile);
		return modifiedWorkfile
	}
}
